{
  "title": "Inventory Management",
  "welcome": "Welcome back, {{name}}",
  "search": "Search Materials, GRNs, or Bin Locations...",
  "inventoryValue": "Inventory Value",
  "lowStock": "Low Stock Alerts",
  "nearExpiry": "Near Expiry",
  "warehouseUtilization": "Warehouse Utilization",
  "totalMaterials": "Total Materials",
  "currentStock": "Current Stock",
  "pendingGrn": "Pending GRN",
  "pendingQc": "Pending QC",
  "pendingPutaway": "Pending Putaway",
  "pendingPickLists": "Pending Pick Lists",
  "todaysInward": "Today's Inward",
  "todaysOutward": "Today's Outward",
  "recentTransactions": "Recent Transactions",
  "viewAll": "View All",
  "quickActions": "Quick Actions",
  "topMovingItems": "Top Moving Items",
  "tabs": {
    "overview": "Overview",
    "inventory": "Inventory",
    "stockAging": "Stock Ageing",
    "procurement": "Procurement",
    "inboundQuality": "Inbound & Quality",
    "outbound": "Outbound",
    "production": "Production",
    "adjustments": "Adjustments",
    "approvals": "Approvals",
    "billing": "Billing",
    "jobWork": "Job Work",
    "weightProduction": "Weigh & Label"
  },
  "billingPanel": {
    "unbilledVas": "Unbilled VAS Charges",
    "draftInvoices": "Draft Invoices",
    "thisMonthBilled": "Billed This Month",
    "unpaidInvoices": "Unpaid Invoices",
    "topUnpaidTitle": "Largest Unpaid Invoices",
    "trendTitle": "Billing Activity — Last 15 Days",
    "trendSubtitle": "Invoiced amount and VAS charges raised, day by day.",
    "billedSeries": "Billed Amount",
    "vasSeries": "VAS Charges Raised",
    "statusTitle": "Invoice Status",
    "categoryTitle": "Billed Amount by Charge Category",
    "topClientsTitle": "Top Clients — Last 30 Days",
    "clientTableTitle": "Client Billing Scorecard",
    "table": {
      "client": "Client",
      "invoicedLast30Days": "Invoiced (Last 30 Days)",
      "unpaidInvoiceCount": "Unpaid Invoices",
      "unbilledVasCount": "Unbilled VAS Charges"
    }
  },
  "overview": {
    "pendingItems": "Pending Items",
    "pendingQueuesTitle": "Pending Work Queues",
    "pendingQueuesSubtitle": "Items currently waiting at each stage of the inbound flow.",
    "stockHealthTitle": "Stock Health",
    "stockHealthSubtitle": "Share of materials that are low on stock or nearing expiry.",
    "healthy": "Healthy",
    "soonestExpiringTitle": "Soonest Expiring Batches"
  },
  "inventory": {
    "totalStockValue": "Total Stock Value",
    "skuCount": "Total SKUs",
    "topMaterialsTitle": "Top Materials by Stock Value",
    "topMaterialsSubtitle": "Highest-value materials currently on hand.",
    "abcTitle": "ABC Analysis",
    "abcSubtitle": "Stock value share by ABC classification.",
    "byCategoryTitle": "Stock Value by Category",
    "lowStockTableTitle": "Materials Below Reorder Level"
  },
  "stockAging": {
    "trackedLines": "Tracked Stock Lines",
    "avgAge": "Avg. Stock Age",
    "oldestAge": "Oldest Stock Age",
    "staleCount": "Aging Over 90 Days",
    "distributionTitle": "Stock Age Distribution",
    "distributionSubtitle": "Stock lines grouped by age band.",
    "lineCount": "Lines",
    "oldestItemsTitle": "Item-Wise Stock Ageing",
    "oldestItemsSubtitle": "Oldest stock on hand, by material, location, and batch.",
    "ageColumn": "Age"
  },
  "procurement": {
    "totalPos": "Total Purchase Orders",
    "totalPoValue": "Total PO Value",
    "pendingPrs": "Pending Purchase Requests",
    "avgOnTime": "Avg. Supplier On-Time %",
    "onTimePercent": "On-Time %",
    "rejectionPercent": "Rejection %",
    "trendTitle": "Purchase Order Value Trend",
    "trendSubtitle": "Total ordered value by month.",
    "statusTitle": "PO Status Distribution",
    "topSuppliersTitle": "Top Suppliers by Ordered Quantity",
    "supplierTableTitle": "Supplier Performance"
  },
  "inboundQuality": {
    "totalGrns": "Total GRNs",
    "acceptedQty": "Accepted Qty",
    "rejectedQty": "Rejected Qty",
    "avgPutawayTat": "Avg. Putaway TAT",
    "acceptRejectTitle": "Accepted vs Rejected Quantity",
    "acceptRejectSubtitle": "Monthly GRN quantity outcomes.",
    "qcStatusTitle": "QC Status Distribution",
    "grnTrendTitle": "GRN Count Trend",
    "grnCount": "GRN Count",
    "grnTableTitle": "Recent GRNs",
    "topRejectedTitle": "Top Rejected Materials"
  },
  "outbound": {
    "totalOrders": "Total Dispatch Orders",
    "issuedQty": "Issued Qty",
    "openOrders": "Open Orders",
    "topCustomersTitle": "Top Customers by Requested Qty",
    "statusTitle": "Dispatch Status Distribution",
    "trendTitle": "Dispatch Orders Trend",
    "customerTableTitle": "Customer Dispatch Summary"
  },
  "production": {
    "totalOrders": "Total Production Orders",
    "producedQty": "Produced Qty",
    "avgYield": "Avg. Yield %",
    "rejectedQty": "Rejected Qty",
    "yieldPercent": "Yield %",
    "rejectionPercent": "Rejection %",
    "plannedVsProducedTitle": "Planned vs Produced Quantity",
    "plannedVsProducedSubtitle": "Monthly production quantity outcomes.",
    "statusTitle": "Production Order Status",
    "yieldByOrderTitle": "Yield % by Order",
    "yieldTableTitle": "Production Yield"
  },
  "adjustments": {
    "totalAdjustments": "Total Adjustments",
    "totalVariance": "Total Variance Qty",
    "totalCycleCounts": "Cycle Counts",
    "totalReturns": "Returns",
    "count": "Count",
    "systemQty": "System Qty",
    "countedQty": "Counted Qty",
    "reasonTitle": "Adjustment Reason Distribution",
    "returnTypeTitle": "Return Type Distribution",
    "trendTitle": "Adjustments Trend",
    "cycleCountTableTitle": "Cycle Count Variance",
    "topVarianceTitle": "Top Materials by Variance"
  },
  "approvals": {
    "pendingCount": "Pending Approvals",
    "overdueCount": "Overdue",
    "avgTurnaround": "Avg. Turnaround",
    "avgPendingAge": "Avg. Pending Age",
    "byTypeTitle": "Pending by Transaction Type",
    "decisionSplitTitle": "Approved vs Rejected",
    "turnaroundByTypeTitle": "Avg. Turnaround by Transaction Type",
    "pendingTableTitle": "Pending Approvals Aging",
    "mostOverdueTitle": "Longest Waiting Approvals"
  },
  "tvDashboard": {
    "toggleFullscreen": "Toggle fullscreen",
    "exit": "Exit TV display",
    "tapToStart": "Tap anywhere to start",
    "tapToStartHint": "Your browser needs one click to enter fullscreen mode.",
    "pause": "Pause auto-scroll",
    "resume": "Resume auto-scroll",
    "previousSlide": "Previous",
    "nextSlide": "Next"
  },
  "jobWork": {
    "totalOrders": "Total Job Work Orders",
    "stillAtVendor": "Still at Vendor",
    "receivedQty": "Received Back",
    "rejectedQty": "Rejected Qty",
    "overdueOrders": "Overdue Orders",
    "expectedVsReceivedTitle": "Expected vs Received Back",
    "expectedVsReceivedSubtitle": "Monthly subcontracting return outcomes.",
    "statusTitle": "Job Work Order Status",
    "pendingByOrderTitle": "Pending at Vendor by Order",
    "pendingTableTitle": "Pending at Vendor"
  },
  "weightProduction": {
    "totalPlans": "Total Weighing Plans",
    "plannedQty": "Planned Qty",
    "producedQty": "Produced Qty",
    "pendingJobCompletion": "Pending Job Completion",
    "overdueEntries": "Overdue Weighings",
    "plannedVsProducedTitle": "Planned vs Produced",
    "plannedVsProducedSubtitle": "Monthly weighing plan progress.",
    "statusTitle": "Plan Status",
    "pendingByAgeTitle": "Pending Job Completion by Age",
    "pendingTableTitle": "Pending Job Completion"
  }
}
